'use client';

import { resolveDefaultMedianIncomeYear } from '@/app/(allowed)/median-income/constants';

import { MobileStickyCalculator } from './MobileStickyCalculator';
import { useMedianIncomeState } from './useMedianIncomeState';

interface MedianIncomePromoMobileProps {
  enabled: boolean;
}

//* 사이드바가 mobile-tablet:hidden aside 안이라 그 안의 fixed 자식도 함께 숨는다 — 마운트 지점이 본문이어야 한다
export const MedianIncomePromoMobile = ({
  enabled,
}: MedianIncomePromoMobileProps) => {
  const state = useMedianIncomeState(resolveDefaultMedianIncomeYear());

  if (!enabled) return null;

  return <MobileStickyCalculator state={state} showNavCta />;
};
